module.exports = __webpack_public_path__ + "static/media/check-mark.6073cf77.svg";